import { ProcessTypes, UserProfile, UserWorkoutSession } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { Platform, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import { TranslateProp } from '../../common-types';
import { Button, ButtonSize } from '../../components';
import { IAppStore } from '../../HomeWorkouts';
import Theme from '../../theme';
import { i18n } from '../../utils';
import { getNextBookingStep as getNextBookingStepAction } from '../actions';
import { BookingFlowFooter, BookingInstructionHeader, GymDropdown } from '../components';
import { OfficeScheduleWarning } from '../components/OfficeScheduleWarning';
import { styles as componentStyles } from '../components/Styles';
import { styles as sharedStyles } from './Styles';

const isWeb = Platform.OS === 'web';

export interface IProps {
  userProfile: UserProfile;
  workoutSession: UserWorkoutSession;
  workoutSessionService: any;
  currentSelectedGymName: string | null;
  isOfficeScheduleBooking: boolean | null;
  fromPlanner: boolean;
  t: TranslateProp;
  getNextBookingStep(userProfile: UserProfile, processTypes: ProcessTypes, fromPlanner: boolean): any;
}

function GymLocation({
  t,
  userProfile,
  workoutSession,
  workoutSessionService,
  currentSelectedGymName,
  isOfficeScheduleBooking,
  getNextBookingStep,
  fromPlanner,
}: IProps) {
  const blockBookingOnWeb = isOfficeScheduleBooking && isWeb;
  const buttonTitle = blockBookingOnWeb ? 'bookings:UseAppForOfficeScheduleWorkouts' : 'bookings:next';

  return (
    <View style={styles.container}>
      <View style={sharedStyles.body}>
        <BookingInstructionHeader header={t('trainAt')} />
        <GymDropdown
          t={t}
          useRadiosSelections={false}
          workoutSession={workoutSession}
          workoutSessionService={workoutSessionService}
          userProfile={userProfile}
        />
        {isOfficeScheduleBooking && currentSelectedGymName && (
          <View style={componentStyles.gymDropdownContainer}>
            <OfficeScheduleWarning
              t={t}
              gymName={currentSelectedGymName}
            />
          </View>
        )}
      </View>
      <BookingFlowFooter style={{}}>
        <Button
          disabled={!currentSelectedGymName || blockBookingOnWeb}
          size={ButtonSize.MEDIUM}
          fontColor={Theme.WHITE}
          title={i18n.t(buttonTitle)}
          onPress={() => getNextBookingStep(userProfile, ProcessTypes.Start, fromPlanner)}
        />
      </BookingFlowFooter>
    </View>
  );
}

const mapStateToProps = (state: IAppStore): Partial<IProps> => ({
  currentSelectedGymName: state.bookings.bookingWizard.currentSelectedGymName,
  isOfficeScheduleBooking: state.bookings.bookingWizard.isOfficeScheduleBooking,
  fromPlanner: state.bookings.bookingWizard.fromPlanner,
});

const mapDispatchToProps = (dispatch) => ({
  getNextBookingStep: (userProfile, processType, fromPlanner) => dispatch(
    getNextBookingStepAction(userProfile, processType, undefined, undefined, fromPlanner),
  ),
});

export const GymLocationStep = connect(mapStateToProps, mapDispatchToProps)(
  translate(['bookings', 'common'], { wait: true })(GymLocation),
);

GymLocationStep.getTitle = () => <></>;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'flex-end',
  },
});
